var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcT({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-t",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.714,
    height: 9,
    viewBox: "0 0 7.714 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "t-solid",
    d: "M.643,32a.643.643,0,1,0,0,1.286H3.214v7.071a.643.643,0,0,0,1.286,0V33.286H7.071a.643.643,0,1,0,0-1.286H.643Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcT);
export default __webpack_public_path__ + "static/media/ic-t.4119f18abb045de271a2035e835ba884.svg";
export { ForwardRef as ReactComponent };